// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment {
  padding: 0 5% 5% 5%;
  min-width: 1200px;
  background: #f3f4f6;
}
.payment__head {
  text-align: center;
}
.payment__head__heading {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 42px;
  line-height: 53px;
  color: #333333;
}
.payment__head__subheading {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  color: #505054;
  margin-bottom: 40px;
}
.payment__body {
  display: flex;
}
.payment__body__col {
  width: 25%;
  padding: 1%;
}
.payment__body__card {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  height: 900px;
  padding: 5%;
}
.payment__body__card-head {
  flex: 0.7 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
}
.payment__body__card-head__section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.payment__body__card-head__package-name {
  padding-top: 25px;
  padding-bottom: 30px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #333333;
}
.payment__body__card-head__package-text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #999999;
}
.payment__body__card-head__package-text2 {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.payment__body__card-head__package-text3 {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #e47c77;
}
.payment__body__card-head__package-dropdown__item {
  width: 100px;
  margin: 20px auto 0;
  height: 40px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px 8px 8px 8px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}
.payment__body__card-head__package-cost {
  position: relative;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 40px;
  color: #333333;
}
.payment__body__card-head__package-cost__price {
  color: #CECECE;
  font-size: 1.5rem;
}
.payment__body__card-head__package-cost-img {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  align-items: center;
  justify-content: center;
}
.payment__body__card-head__package-cost-img img {
  transform: translateY(45%);
}
.payment__body__card-head__package-discount {
  display: flex;
  position: absolute;
  right: 0;
  padding: 2px 3px;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background-color: #E47C77;
  transform: translateY(45%);
}
.payment__body__card-head__package-discount span {
  color: white;
  font-size: 0.85rem;
}
.payment__body__card-head__package-use {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #49ae9e;
}
.payment__body__card-body {
  flex: 1 1;
  padding: 20px 5px;
  border-top: 1px solid #f2f2f2;
}
.payment__body__card-body__avail-app {
  padding-top: 25px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  color: #505054;
}
.payment__body__card-body__feature {
  display: flex;
  padding-top: 10px;
}
.payment__body__card-body__feature__text-underline {
  padding-left: 5px;
  padding-top: 2px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
  background: linear-gradient(180deg, #ffffff 50%, #fff0c4 50%);
}
.payment__body__card-body__feature__text {
  padding-left: 5px;
  padding-top: 2px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
}
.payment__body__card-body__feature__value {
  padding-left: 5px;
  padding-top: 2px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #075453;
}

.plans__headers {
  width: 10%;
}

.plans-headers {
  display: flex;
  height: 100%;
}
.plans-headers__head {
  margin: 0 auto;
  background-color: #d9d9d9;
  border-radius: 10px;
  padding: 30px;
  width: 100%;
  height: 100%;
}

.plans-table__tr {
  height: 100px;
}
.plans-table__td-h {
  background-color: #d9d9d9;
  border-radius: 20px;
  border: 10px solid white;
  width: 10%;
  text-align: center;
}
.plans-table__td {
  border-right: 1px solid #d9d9d9;
  width: 20%;
  text-align: center;
}
.plans-table__td-plan-name {
  border-right: 1px solid white;
  width: 20%;
  text-align: center;
}

.decision {
  margin: auto;
  width: 40%;
  margin-top: 20px;
}
.decision__button {
  border: 1px solid #28b294;
  padding: 3px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 10px;
  font-family: "Noto Sans KR";
  font-style: normal;
  color: #28b294;
  cursor: pointer;
}

.emailApply {
  margin-top: 10%;
}
.emailApply .desc {
  text-align: center;
}
.emailApply .desc span {
  color: #999;
  font-size: 1.2rem;
}
.emailApply .form {
  margin-top: 10%;
  min-width: 300px;
}
.emailApply .form .inputArea {
  display: flex;
  width: 100%;
}
.emailApply .form .inputArea .emailInput {
  flex: 1 1;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  text-indent: 10px;
}
.emailApply .form .inputArea .submitInput {
  margin-left: 10px;
  padding: 15px 20px;
  color: #49ae9e;
  font-size: 1.2rem;
  border: none;
  border-radius: 8px;
  background-color: #e5f4f2;
  cursor: pointer;
}
.emailApply .form .errorArea {
  margin-top: 5px;
}
.emailApply .form .errorArea span {
  color: #e47c77;
}`, "",{"version":3,"sources":["webpack://./src/screens/payment/payment.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,iBAAA;EACA,mBAAA;AACJ;AACI;EACI,kBAAA;AACR;AACQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACZ;AAEQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAAZ;AAII;EACI,aAAA;AAFR;AAIQ;EACI,UAAA;EACA,WAAA;AAFZ;AAKQ;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,4CAAA;EACA,aAAA;EACA,WAAA;AAHZ;AAMQ;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,kBAAA;AAJZ;AAOY;EACI,SAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;AALhB;AAQY;EACI,iBAAA;EACA,oBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AANhB;AASY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAPhB;AAUY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AARhB;AAWY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAThB;AAagB;EACI,YAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAZpB;AAgBY;EACI,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAdhB;AAgBgB;EACI,cAAA;EACA,iBAAA;AAdpB;AAkBY;EACI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AAhBhB;AAkBgB;EACI,0BAAA;AAhBpB;AAoBY;EACI,aAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,0BAAA;AAlBhB;AAoBgB;EACI,YAAA;EACA,kBAAA;AAlBpB;AA0BY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAxBhB;AA+BQ;EACI,SAAA;EACA,iBAAA;EACA,6BAAA;AA7BZ;AA+BY;EACI,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA7BhB;AAgCY;EACI,aAAA;EACA,iBAAA;AA9BhB;AAgCgB;EACI,iBAAA;EACA,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,6DAAA;AA9BpB;AAiCgB;EACI,iBAAA;EACA,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA/BpB;AAkCgB;EACI,iBAAA;EACA,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAhCpB;;AAwCI;EACI,UAAA;AArCR;;AAyCA;EACI,aAAA;EACA,YAAA;AAtCJ;AAwCI;EACI,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AAtCR;;AA2CI;EACI,aAAA;AAxCR;AA2CI;EACI,yBAAA;EACA,mBAAA;EACA,wBAAA;EACA,UAAA;EACA,kBAAA;AAzCR;AA4CI;EACI,+BAAA;EACA,UAAA;EACA,kBAAA;AA1CR;AA6CI;EACI,6BAAA;EACA,UAAA;EACA,kBAAA;AA3CR;;AA+CA;EACI,YAAA;EACA,UAAA;EACA,gBAAA;AA5CJ;AA8CI;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,2BAAA;EACA,kBAAA;EACA,cAAA;EAEA,eAAA;AA9CR;;AAkDA;EAEI,eAAA;AAhDJ;AAkDI;EACI,kBAAA;AAhDR;AAkDQ;EACI,WAAA;EACA,iBAAA;AAhDZ;AAmDI;EACI,eAAA;EACA,gBAAA;AAjDR;AAmDQ;EACI,aAAA;EACA,WAAA;AAjDZ;AAmDY;EACI,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AAjDhB;AAmDY;EACI,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AAjDhB;AAqDQ;EACI,eAAA;AAnDZ;AAqDY;EACI,cAAA;AAnDhB","sourcesContent":[".payment {\n    padding: 0 5% 5% 5%;\n    min-width: 1200px;\n    background: #f3f4f6;\n\n    &__head {\n        text-align: center;\n\n        &__heading {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 42px;\n            line-height: 53px;\n            color: #333333;\n        }\n\n        &__subheading {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 18px;\n            line-height: 26px;\n            color: #505054;\n            margin-bottom: 40px;\n        }\n    }\n\n    &__body {\n        display: flex;\n\n        &__col {\n            width: 25%;\n            padding: 1%;\n        }\n\n        &__card {\n            display: flex;\n            flex-direction: column;\n            width: 100%;\n            background: white;\n            border-radius: 12px;\n            box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n            height: 900px;\n            padding: 5%;\n        }\n\n        &__card-head {\n            flex: 0.7;\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n            text-align: center;\n\n\n            &__section {\n                flex: 1;\n                display: flex;\n                flex-direction: column;\n                justify-content: space-evenly;\n            }\n\n            &__package-name {\n                padding-top: 25px;\n                padding-bottom: 30px;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 20px;\n                line-height: 30px;\n                color: #333333;\n            }\n\n            &__package-text {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                color: #999999;\n            }\n\n            &__package-text2 {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n            }\n\n            &__package-text3 {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                color: #e47c77;\n            }\n\n            &__package-dropdown {\n                &__item {\n                    width: 100px;\n                    margin: 20px auto 0;\n                    height: 40px;\n                    background: #ffffff;\n                    border: 1px solid #e9e9e9;\n                    border-radius: 8px 8px 8px 8px;\n\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 400;\n                    font-size: 14px;\n                }\n            }\n\n            &__package-cost {\n                position: relative;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 30px;\n                line-height: 40px;\n                color: #333333;\n\n                &__price {\n                    color: #CECECE;\n                    font-size: 1.5rem;\n                }\n            }\n\n            &__package-cost-img {\n                display: flex;\n                position: absolute;\n                top: 0;\n                left: 0;\n                right: 0;\n                bottom: 0;\n                align-items: center;\n                justify-content: center;\n\n                img {\n                    transform: translateY(45%);\n                }\n            }\n\n            &__package-discount {\n                display: flex;\n                position: absolute;\n                right: 0;\n                padding: 2px 3px;\n                align-items: center;\n                justify-content: center;\n                border-radius: 6px;\n                background-color: #E47C77;\n                transform: translateY(45%);\n\n                span {\n                    color: white;\n                    font-size: 0.85rem;\n                }\n            }\n\n            &__package-discost {\n                \n            }\n\n            &__package-use {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 16px;\n                line-height: 22px;\n                color: #49ae9e;\n            }\n\n            &__package-button {\n            }\n        }\n\n        &__card-body {\n            flex: 1;\n            padding: 20px 5px;\n            border-top: 1px solid #f2f2f2;\n\n            &__avail-app {\n                padding-top: 25px;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 12px;\n                line-height: 18px;\n                color: #505054;\n            }\n\n            &__feature {\n                display: flex;\n                padding-top: 10px;\n\n                &__text-underline {\n                    padding-left: 5px;\n                    padding-top: 2px;\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 400;\n                    font-size: 14px;\n                    line-height: 20px;\n                    color: #868686;\n                    background: linear-gradient(180deg, #ffffff 50%, #fff0c4 50%);\n                }\n\n                &__text {\n                    padding-left: 5px;\n                    padding-top: 2px;\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 400;\n                    font-size: 14px;\n                    line-height: 20px;\n                    color: #868686;\n                }\n\n                &__value {\n                    padding-left: 5px;\n                    padding-top: 2px;\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 500;\n                    font-size: 14px;\n                    line-height: 20px;\n                    color: #075453;\n                }\n            }\n        }\n    }\n}\n\n.plans {\n    &__headers {\n        width: 10%;\n    }\n}\n\n.plans-headers {\n    display: flex;\n    height: 100%;\n\n    &__head {\n        margin: 0 auto;\n        background-color: #d9d9d9;\n        border-radius: 10px;\n        padding: 30px;\n        width: 100%;\n        height: 100%;\n    }\n}\n\n.plans-table {\n    &__tr {\n        height: 100px;\n    }\n\n    &__td-h {\n        background-color: #d9d9d9;\n        border-radius: 20px;\n        border: 10px solid white;\n        width: 10%;\n        text-align: center;\n    }\n\n    &__td {\n        border-right: 1px solid #d9d9d9;\n        width: 20%;\n        text-align: center;\n    }\n\n    &__td-plan-name {\n        border-right: 1px solid white;\n        width: 20%;\n        text-align: center;\n    }\n}\n\n.decision {\n    margin: auto;\n    width: 40%;\n    margin-top: 20px;\n\n    &__button {\n        border: 1px solid #28b294;\n        padding: 3px;\n        padding-left: 20px;\n        padding-right: 20px;\n        border-radius: 10px;\n\n        font-family: 'Noto Sans KR';\n        font-style: normal;\n        color: #28b294;\n\n        cursor: pointer;\n    }\n}\n\n.emailApply {\n\n    margin-top: 10%;\n\n    .desc {\n        text-align: center;\n\n        span {\n            color: #999;\n            font-size: 1.2rem;\n        }\n    }\n    .form {\n        margin-top: 10%;\n        min-width: 300px;\n\n        .inputArea {\n            display: flex;\n            width: 100%;\n\n            .emailInput {\n                flex: 1;\n                border: 1px solid #e9e9e9;\n                border-radius: 8px;\n                text-indent: 10px;\n            }\n            .submitInput {\n                margin-left: 10px;\n                padding: 15px 20px;\n                color: #49ae9e;\n                font-size: 1.2rem;\n                border: none;\n                border-radius: 8px;\n                background-color: #e5f4f2;\n                cursor: pointer;\n            }\n        }\n\n        .errorArea {\n            margin-top: 5px;\n\n            span {\n                color: #e47c77;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
